import { FC, useEffect } from "react";
import styles from "./MailingSettings.module.scss";
import { Button, Title } from "@/shared";
import { useAppDispatch, useAppSelector } from "@/shared/hooks";
import { SubscriptionKey } from "@/entities/mailerSettings/type";

import {
  getMailingUsersList,
  getUserMailingSettings,
  setCurrentUser,
} from "@/entities/mailerSettings/slice";
import { SubscriptionItem } from "./subscriptionItem/SubscriptionItem";
import { useDrawer } from "@/app/providers/DrawerProvider/useDrawer";

interface MailingSettingsProps {
  userId: string;
  dealerId: string;
}
const subsType: SubscriptionKey[] = [
  "orderPd",
  "salesAndRemainsWeekly",
  "accountsReceivable",
  "pledgeBook",
  "salesAndRemainsMonthly",
];

export const MailingSettings: FC<MailingSettingsProps> = ({
  userId,
  dealerId,
}) => {
  const dispatch = useAppDispatch();
  const { currentUser } = useAppSelector((state) => state.mailing);

  const { closeDrawer } = useDrawer();

  useEffect(() => {
    dispatch(getUserMailingSettings(userId));
    dispatch(getMailingUsersList(dealerId));
  }, []);

  return (
    <div className={styles.mainContainer}>
      <div className={styles.content}>
        <Title text="Вид рассылки" type="default" />
        {currentUser &&
          subsType.map((item) => (
            <SubscriptionItem
              key={item}
              mailingType={item}
              currentUser={currentUser}
            />
          ))}
        <div className={styles.actionButtons}>
          <Button
            buttontStyle="cancelBtn"
            name="Закрыть"
            onClick={() => {
              closeDrawer();
              dispatch(setCurrentUser(null));
            }}
          />
        </div>
      </div>
    </div>
  );
};
